import React from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column, InputText, Dialog, InputTextarea, Toast } from "primereact";
import { Formik } from "formik";
import ReactGA from "react-ga4";
import Moment from "moment";

import "../../assets/css/badge.css";

class ListaNotarizzazioni extends React.Component {
  constructor() {
    super();
    this.actions = [
      {
        id: 1,
        icon: "pi-search",
        label: "",
        action: (id) => {
          this.vai(id, "V");
          console.log("View " + id);
        },
      },
    ];
    this.state = {
      activePage: 0,
      lista: [],
      totalRecords: 0,
      first: 0,
      rows: 10,
      loading: true,
      visible1: false,
    };

    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.state = {
      xcarica: "sezione",
      dati: [],
      activePage: 1,
      totalRecords: 0,
      pageSize: 10,
      first: 0,
      visible2: false,
      visible3: false,
      singolo: {},
    };
    this.onPage = this.onPage.bind(this);
    this.aziendaid = this.utente.aziendaid;
    this.notarizzazioneid = 0;
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }

  componentDidMount() {
    //alert(this.props.location.pathname);
    //ReactGA.send({ hitType: "pageview", page: this.props.location.pathname });
    // this.prodottoid=(this.props.prodottoid?this.props.prodottoid:-1);
    this.caricaDati(1, this.state.pageSize);
  }

  caricaDati(pagina, numrec) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    var quer = "page=" + pagina + "&num=" + numrec + "&aziendaid=" + this.aziendaid + "&tipo=1";
    axios
      .get(Costanti.UrlCallApi + "notarizzazione/all?" + quer, config)
      .then((res) => {
        res.data.lista1.forEach((element) => {
          element.azioni = this.actions;
        });
        this.setState({ dati: res.data.lista1, totalRecords: res.data.conta1, loading: false });

        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }

  caricaSingolo(id) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    axios
      .get(Costanti.UrlCallApi + "notarizzazione/" + id, config)
      .then((res) => {
        this.setState({ singolo: res.data, loading: false });
        this.notarizzazioneid = id;
        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
        this.notarizzazioneid = 0;
      });
  }

  salva(values) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ isSubmitting: true });

    if (this.state.tipo == "U") {
      axios
        .post(Costanti.UrlCallApi + "notarizzazione/salva/" + this.state.singolo.id, values, config)
        .then(() => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
    if (this.state.tipo == "A") {
      var dato = {
        datains: null,
        dataupd: null,
        id: 0,
        nome: values.nome,
        descrizione: values.descrizione,
        tipo: 1,
        idcollegato: this.prodottoid,
        uteins: 1,
        uteupd: null,
      };
      axios
        .post(Costanti.UrlCallApi + "notarizzazione/aggiungi", dato, config)
        .then(() => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }

    setTimeout(() => this.setVisible1(false), 1000);
  }

  setVisible1(val) {
    this.setState({ visible1: val });
    this.caricaDati(this.state.activePage, this.state.pageSize);
  }

  vai(id, tipo) {
    this.caricaSingolo(id);
    this.setVisible1(true);
    this.setState({ tipo: tipo });
    switch (tipo) {
      case "A":
        this.setState({ editMode: true, singolo: {}, intestazione: "Aggiungi Notarizzazione" });
        break;
      case "V":
        this.setState({ intestazione: "Visualizza Notarizzazione" });
        break;
      case "D":
        this.setState({ intestazione: "Elimina Notarizzazione" });
        break;
      case "U":
        this.setState({ editMode: true, intestazione: "Modifica Notarizzazione" });
        break;
    }
  }
  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize);
  }

  setPDF(value) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/notarizzazioni/" + this.aziendaid, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }

  render() {
    return (
      <div>
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>
        <DataTable
          value={this.state.dati}
          rows={this.state.pageSize}
          totalRecords={this.state.totalRecords}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
          paginator={true}
          onPage={this.onPage}
          loading={this.state.loading}
          lazy={true}
          first={this.state.first}
          header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista Notarizzazioni</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />
              <Button
                label="Esporta in Pdf"
                onClick={() => this.setPDF(true)}
                icon="pi pi-file-pdf"
                className="p-button-rounded p-button-danger "
              />
            </div>
          }
          responsiveLayout="stack"
        >
          <Column
            id="id1"
            header="HASH"
            body={(item) => (
              <div className="wrapper">
                <p className="demo-1">{item.hash}</p>
              </div>
            )}
          />
          <Column
            id="id2"
            header="Data"
            body={(item) => Moment(new Date(item.datains)).format("DD/MM/yyyy HH:mm:ss")}
          />

          <Column
            id="id2"
            header="Transazione"
            body={(item) => (
              <div className="wrapper">
                <p className="demo-1">{item.transazione}</p>
              </div>
            )}
          />
          <Column id="id2" field="note" header="Note" />
          <Column
            id="id0"
            header=""
            body={(item) => (
              <a href={Costanti.UrlCallApi + "file/getHash/" + item.hash}>
                <img src="assets/layout/images/pdf.png" />
              </a>
            )}
          />
          <Column
            id="id5"
            field="id"
            header="Azioni"
            body={(item) => (
              <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                {this.actions.map((action) => (
                  <Button
                    key={action.id}
                    className="p-button-sm"
                    icon={`pi ${action.icon}`}
                    label={action.label}
                    aria-label={action.label}
                    onClick={(e) => {
                      e.stopPropagation();
                      action.action(item.id);
                    }}
                  />
                ))}
              </div>
            )}
          ></Column>
        </DataTable>

        <Dialog
          header={this.state.intestazione}
          closable={false}
          visible={this.state.visible1}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <div className="flex flex-wrap border-top-1 surface-border pt-4">
            <div className="surface-card p-2  border-round">
              <Formik
                initialValues={{
                  hash: this.state.singolo.hash,
                  transazione: this.state.singolo.transazione,
                  note: this.state.singolo.note,
                  dati: this.state.singolo.dati,
                  tipo: this.state.singolo.tipo,
                  idcollegato: this.state.singolo.idcollegato,
                }}
                enableReinitialize
                validationSchema={this.validationSchema}
                onSubmit={(values) => {
                  this.salva(values);
                }}
              >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="grid formgrid p-fluid">
                      <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

                      <div className="field mb-1 col-12 md:col-12">
                        <label htmlFor="hash" className="font-medium text-600">
                          HASH
                        </label>
                        <InputText
                          name="nome"
                          readOnly={!this.state.editMode}
                          value={values.hash}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="text"
                        />
                      </div>
                      <div className="field mb-1 col-12 md:col-12">
                        <label htmlFor="transazione" className="font-medium text-600">
                          Transazione
                        </label>
                        <InputText
                          name="transazione"
                          readOnly={!this.state.editMode}
                          value={values.transazione}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="text"
                        />
                        <a
                          href={
                            "https://lora.algokit.io/mainnet/transaction/"+
                            (values.transazione == null ? "" : values.transazione)
                          }
                          target="_blank"
                        >
                          {values.transazione == null ? "" : "Visualizza su BlockChain"}
                        </a>
                      </div>
                      <div className="field mb-1 col-12 md:col-12">
                        <label htmlFor="dati" className="font-medium text-600">
                          dati
                        </label>
                        <InputText
                          name="dati"
                          readOnly={!this.state.editMode}
                          value={values.dati}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="text"
                        />
                      </div>
                      <div className="field mb-1 col-12 md:col-12">
                        <label htmlFor="note" className="font-medium text-600">
                          Note
                        </label>
                        <InputTextarea
                          id="note"
                          type="text"
                          rows={10}
                          autoResize
                          value={values.note}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                    </div>
                    <footer>
                      <div className="border-top-1 surface-border pt-3">
                        <Button type="submit" visible={this.state.tipo == "U"} icon="pi pi-save" label="Salva" />
                        <Button visible={this.state.tipo == "A"} icon="pi pi-save" label="Aggiungi" />
                        <Button visible={this.state.tipo == "D"} icon="pi pi-save" label="Elimina" />
                        <Button
                          type="button"
                          icon="pi pi-check"
                          onClick={() => this.setVisible1(false)}
                          label="Chiudi"
                        />
                      </div>
                    </footer>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default ListaNotarizzazioni;
